//import CreditCardType from 'credit-card-type';
import getLanguage from './get-language.js';
import generateSessiondIdIfNotExists from './generate-sessionid.js';
import {
    hideValidationMessage,
    showValidationMessage
} from './form-validation-message.js';
import { setMonthPickers } from "../js/v2/rmo/set-date-picker.js"


(async () => {
    const addBank = document.getElementById('addBank')
    if(addBank) {
       
        const { lang } = getLanguage();
        const loader = addBank.querySelector("#addBankLoader");
        const container = addBank.querySelector("#addBankContainer");
        const bankDropdownSection = addBank.querySelector("#bank_dropdown");
        const BankSection = addBank.querySelector(".bank-container");
        const ClabeSection = addBank.querySelector(".CLABE-container");
        const accountNumSection = addBank.querySelector(
          ".Account_Number-container"
        );
        const clabeInput = addBank.querySelector("#input-clabe-num");
        const clabErrEle = addBank.querySelector(".input-clabe-err-msg");
        const accountNumInput = addBank.querySelector("#input-account-num");
        const reAccountNumInput = addBank.querySelector(
          "#input-re-account-num"
        );
        const reClabeNumInput = addBank.querySelector("#input-re-clabe-num");
        const accountDropdownSection = addBank.querySelector(
          "#account_type_dropdown"
        );
        const accountDropdown =
          accountDropdownSection.querySelector(".accountDropEle");
        const inputAccountType = accountDropdownSection?.querySelector(
          ".b-flag-select__search-field"
        );
        const inputAccountTypeLabelBank = accountDropdownSection?.querySelector(
          ".b-flag-select__value"
        );
        const accountTypeList = accountDropdown?.querySelector(
          ".b-flag-select__list"
        );

        // const whatsappTimer = addBank.querySelector('#whatsappTimer')
        const dropdownBank = addBank.querySelector('.bankDropdownEle')
        const estimatedDelText = addBank.querySelector('#estimated-delivery-text')
        const bankSelectionText = addBank.querySelector('#bankSelectionText')
        const unorderedListBank = dropdownBank?.querySelector('.b-flag-select__list')
        const completeFields = addBank.querySelector('#complete-fields')
        let banksInList = []
        const inputBank = dropdownBank?.querySelector('.b-flag-select__search-field')
        const inputLabelBank =dropdownBank?.querySelector('.b-flag-select__value')
        const bankSelected = addBank.querySelector('#bankSelected')
        const saveAddBank = addBank.querySelector('#save-add-bank')
        const bankAddedSuccessfully = addBank.querySelector('#bankAddedSuccessfully')
        const successMessage = bankAddedSuccessfully.querySelector('.success')
        const error500Message = bankAddedSuccessfully.querySelector('.error-500')
        const errorOtherMessage = bankAddedSuccessfully.querySelector('.error-other')

     
        //query parameters
        let token =getUrlParameter('token') || ''
        token = token?.startsWith('Bearer') ? token : `Bearer ${token}`
        const senderCountry = getUrlParameter('senderCountry')?.toUpperCase() ||"US"
        const receiverCountry = getUrlParameter('receiverCountry')?.toUpperCase() || "MX"
        const customerID = getUrlParameter('customerID')
        let PayIN = getUrlParameter('PayIN') ||"AC"
        const PayOut = 'Bank'
       
        let countryCode = getUrlParameter('countryCode')
        const languageFromUrl = getLocalLanguage(lang);
        const sessionId = window.sessionStorage.getItem("trans-wa-sessionId") ||  await generateSessiondIdIfNotExists("", receiverCountry, languageFromUrl)
        CookieService.setCookie('SessionId', sessionId, 30, '/', true, ".westernunion.com");
        const externalRefId =  window.sessionStorage.getItem("trans-wa-externalRefId") || getUrlParameter('id')|| sessionId;
        //Update external RefId if it comes through url parameters
        window.sessionStorage.setItem("trans-wa-externalRefId",externalRefId)
        const individualInputContainer = addBank.querySelectorAll('.individual-input-container')
        const mtcn =  window.sessionStorage.getItem("trans-wa-mtcn") || getUrlParameter('MTCN')||getUrlParameter('mtcn')||''
        const addBankFormError= addBank.querySelector('#addBankFormError')
        const formValidObj = {isValid: false} 
        let counterFormError = 0 
        const maxCounterFormError = +addBankFormError.getAttribute('counter')
        const validForm = new Proxy({}, {
            set: function(target, property, value) {
                target = {...target, property: value}
                let type = selectedAccountTypeExactVal
                let testBankValue = false;
                if(property === 'isValid' && value === 'false') {
                        formValidObj.isValid = false
                        saveAddBank.setAttribute('disabled', true)
                } else if(property === 'isValid' && value === 'true') {
                    if(testBankValue && !inputLabelBank.innerText) {
                        formValidObj.isValid = false
                        saveAddBank.setAttribute('disabled', true)
                    } else {
                        formValidObj.isValid = true
                        saveAddBank.removeAttribute('disabled')
                    }
                }
                return true
            }
        });
        let customerDataBank;
        let selectAccountType;
        let selectedAccountTypeExactVal;

        const validateForm = ()=>{
            let bankInputsFlag = false;
            const data_bank = bankSelected.getAttribute('data-bank');
            if(data_bank === null || data_bank === undefined || data_bank === '')
            {bankInputsFlag = false }
            else {bankInputsFlag = true}
          
            if (formValidObj.isValid && bankInputsFlag) {
              saveAddBank.removeAttribute("disabled");
            } else {
              saveAddBank.setAttribute("disabled", true);
            }
        }
       
        const toggleDropdown = (closeDropdown ,dropdownElem ) => {
            if(closeDropdown){
                toggleClass( dropdownElem , 'd-block', 'd-none')
                return;
            } 
            if (dropdownElem.classList.contains('d-none')) {
                toggleClass(dropdownElem, 'd-none', 'd-block')
            } else {
                toggleClass(dropdownElem, 'd-block', 'd-none')
            }
        }

        const toggleInputLabelBank = (labelDisplay) => {
            if(labelDisplay) {
                toggleClass(inputLabelBank, 'd-none', 'd-block')
                inputBank.classList.add('d-none')
            } else {
                toggleClass(inputLabelBank, 'd-block', 'd-none')
                inputBank.classList.remove('d-none')
            }
        }


        const searchFilter = (val) => {
            Array.prototype.slice.call(banksInList).forEach(item => {
                let parsedText = item.innerText.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                let parsedValue = val.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                if((!val) || (parsedText && val && parsedValue && (parsedText.toLowerCase().indexOf(parsedValue.toLowerCase()) !== -1 || item.innerText.toLowerCase().indexOf(val.toLowerCase()) !== -1))) {
                    item.classList.remove('d-none')
                    item.classList.add('d-flex')
                } else {
                    item.classList.add('d-none')
                    item.classList.remove('d-flex')
                }
            })
        }

        inputBank?.addEventListener("input", (e) => {
        inputLabelBank.innerText = e.target.value
        toggleClass(estimatedDelText, "d-block", "d-none");
        if (
          e.target.value !== bankSelected?.getAttribute("data-bank") ||
          e.target.value === "" ||
          e.target.value === undefined
        ) {
          bankSelected.setAttribute("data-bank", "");
          bankSelected.setAttribute("data-code", "");
          toggleClass(bankSelectionText, "d-none", "d-block");
        } else {
          toggleClass(bankSelectionText, "d-block", "d-none");
        }    
        searchFilter(e.target.value);
        validateForm();
                
        });
        
        inputBank?.addEventListener('click', (e) => {
            e.stopPropagation();
        })

        inputAccountType?.addEventListener('click', (e) => {
            e.stopPropagation();
        })

        dropdownFeature(bankDropdownSection)
        dropdownFeature(accountDropdownSection)
        
        const addLiTounorderedListBank = (text, value, msg,fragment) => {
            let li = document.createElement('li');
            li.className = 'wuds-dropdown__items b-flag-select__item pad-8-lt';
            li.setAttribute('data-text', text)
            li.setAttribute('data-value', value)
            const message = msg?.account_number ? msg?.account_number :  document.querySelector("#acc_validation_msg").innerText;
            li.setAttribute('data-msg', message);
            li.innerText = text
            fragment.append(li)
        }

        const validateInputs = (target) => {
            let valueInInput = target.value;
            let selectedBank = bankSelected.getAttribute('data-bank')
            let selectedBankCode = bankSelected.getAttribute('data-code')
            if (target.classList.contains('CLABE-input')) {
                let clabeIpValid = false;
                let reClabeIpValid = false;
                if (!/^[0-9]{18}$/.test(valueInInput)) {
                  clabErrEle.innerText = inputBank.getAttribute("data-msg");
                  let msg = inputBank.getAttribute("data-msg");
                  showValidationMessage(target);
                  clabeIpValid = false;    
                }  else {
                  clabErrEle.innerText = "";
                  hideValidationMessage(target);
                   clabeIpValid = true;
                }

                if (checkRenteredValues(clabeInput.value, reClabeNumInput.value) ) {
                 hideValidationMessage(reClabeNumInput);
                 reClabeIpValid = true; 
               } else {
                 showValidationMessage(reClabeNumInput);
                 reClabeIpValid = false;
               }
               if (clabeIpValid && reClabeIpValid) {
                 formValidObj.isValid = true;
               } else {
                 formValidObj.isValid = false;
               }
               validateForm();
            } 
               
            else if (target.classList.contains('Account-input')){
                let AccIpValid = false;
                let reAccIpValid = false;
                
                if(!(/^[0-9]{10,20}$/.test(valueInInput))) {
                    showValidationMessage(target)
                    AccIpValid = false;
                }               
                else {
                    hideValidationMessage(reAccountNumInput)
                    hideValidationMessage(target)
                     AccIpValid = true; 
                }

                if (
                  checkRenteredValues(
                    accountNumInput.value,
                    reAccountNumInput.value
                  )
                ) {
                  hideValidationMessage(reAccountNumInput);
                  reAccIpValid = true;
                } else {
                  showValidationMessage(reAccountNumInput);
                  reAccIpValid = false;
                }

               if (AccIpValid && reAccIpValid) {
                 formValidObj.isValid = true;
               } else {
                 formValidObj.isValid = false;
               }
               validateForm();
            }   
           
        }

        const checkRenteredValues = (acc_num , re_acc_num)=>{
            return (acc_num ===re_acc_num ?  true : false)      
        }
        const checkInputs = (payOutType)=>{ 
            if (payOutType == "CLABE") {
             clabeInput.addEventListener("input", (e) => {
               clabeInput.setAttribute('value',e.target.value)
               validateInputs(e.target);
             });
             reClabeNumInput.addEventListener("input", (e) => {
               reClabeNumInput.setAttribute("value", e.target.value);
               validateInputs(e.target)
             });

           } else if (payOutType == "Account") {
            
             accountNumInput.addEventListener("input", (e) => {
               accountNumInput.setAttribute('value',e.target.value)
               validateInputs(e.target);
             });

             reAccountNumInput.addEventListener("input", (e) => {
               reAccountNumInput.setAttribute("value", e.target.value);
               validateInputs(e.target);
             });
             
           }
        }
       
        const showHidePayoutDetails = (selectAccountType)=>{
            if (selectAccountType === "CLABE") {
              toggleClass(ClabeSection, "d-none", "d-block");
              toggleClass(accountNumSection, "d-block", "d-none");
            } else {
              toggleClass(ClabeSection, "d-block", "d-none");
              toggleClass(accountNumSection, "d-none", "d-block");
            }
             checkInputs(selectAccountType)
        }
        const cleanStorageData = () => {
            const storeValues = ['trans-wa-app', 'trans-wa-masked-phoneno', 'trans-wa-mtcn', 'trans-wa-externalRefId', 'trans-wa-sessionId','trans-wa-stateToken']
            storeValues.forEach((key) => {
                if (window.sessionStorage.getItem(key) !== null) {
                    window.sessionStorage.removeItem(key)
                }
            })
        }

        const showThankYouScreen = (element) => {
            cleanStorageData()
            container.classList.add('d-none');
            bankAddedSuccessfully.classList.remove('d-none');
            bankAddedSuccessfully.classList.add('d-flex');
            const whatsappTimer = element.querySelector('.whatsapp-timer')
            let counter = 5
            whatsappTimer.innerText = counter--
            const interval = setInterval(() => {
                whatsappTimer.innerText = counter--
                if(counter === 0) {
                    location.href = `https://wa.me`
                    clearInterval(interval);
                }
            },1000)
        }

        const showErrorOrThanxScreen = (response) => {  
            if(response && response.ok === false && response.wrongParams) {
                showThankYouScreen(errorOtherMessage);
                toggleClass(errorOtherMessage, 'd-none', 'd-flex')
            } else if(response.ok === false && response.status === 500){
                showThankYouScreen(error500Message);
                toggleClass(error500Message, 'd-none','d-flex')
            } else if(response.ok === false && response.status === 401 || response.status === 400){
                showThankYouScreen(errorOtherMessage);
                toggleClass(errorOtherMessage, 'd-none','d-flex')
            }
            else if(
                !response || 
                (response.errorCode && response.message) || 
                (response.ok === false && response.status !== 500)
            ) {
                counterFormError++;
                if(maxCounterFormError === counterFormError) {
                    showThankYouScreen(errorOtherMessage);
                    toggleClass(errorOtherMessage, 'd-none','d-flex')
                } else {
                    const errorMessage = errorOtherMessage.getAttribute(`data-error-${response.errorCode}`)
                    addBankFormError.classList.remove('d-none');
                    addBankFormError.innerText = errorMessage || response.message || response.statusText || 'An error has occurred. Please try again.';
                }
            } else if(response) {
                showThankYouScreen(successMessage);
                toggleClass(successMessage, 'd-none','d-flex')
            }
        }

        const resetFormDetails =()=>{
            const inputs = document.querySelectorAll('.bank_input')
            inputs.forEach((ip)=>{
                ip.value = "";
                if(ip.parentElement.classList.contains('wu-input--error')){
                     hideValidationMessage(ip);
                }
            })
            bankSelected.setAttribute('data-bank',"")
            bankSelected.setAttribute('data-code',"")
            inputBank.value = ""
            inputBank.setAttribute('value', '')
            inputBank.setAttribute('data-msg','')
            inputLabelBank.innerText = ""
            toggleClass(bankSelectionText, "d-block", "d-none");
            searchFilter('')
        }

        const triggerAddBank = async (customerID) => {
            var headersAddBank = new Headers();
            const unqueId = `web-` + generateUniqueID();
            headersAddBank.append("x-wu-externalRefId", externalRefId);
            headersAddBank.append("x-wu-apiKey", `123`);
            headersAddBank.append("x-wu-correlationId", `web-` + generateUniqueID());
            headersAddBank.append("x-wu-accountNumber", customerID);
            headersAddBank.append("Authorization", token);
            headersAddBank.append("Content-Type", "application/json");
            headersAddBank.append("WUCountryCode", receiverCountry.toUpperCase());
            headersAddBank.append("x-wu-countryCode", receiverCountry.toUpperCase());
            headersAddBank.append("WULanguageCode", languageFromUrl);
            headersAddBank.append("r3APIEnabled", true);
            headersAddBank.append("ApplicationSource", "WHATSAPP");
            headersAddBank.append("x-wu-redirect-mtcn", mtcn);
            headersAddBank.append("Accept-Language", `${languageFromUrl}-${receiverCountry}`);
            
            if(sessionId) headersAddBank.append('x-wu-sessionId', sessionId)
                
            let accountTypeVal = selectAccountType
            let accountNumber = addBank.querySelector(`.${accountTypeVal}-input`).value
        
            if(accountTypeVal === 'CLABE' || accountTypeVal === "Account") {
                const body = {
                    "bank": {
                        accountNumber,
                        accountType : accountTypeVal,
                        "code": bankSelected.getAttribute('data-code'),
                        "name": bankSelected.getAttribute('data-bank'),
                        "address": {
                            countryCode : receiverCountry
                        }
                    },
                    
                }
                const requestOptions = {
                    method: "POST",
                    headers: headersAddBank,
                    body: JSON.stringify(body),
                    redirect: "follow"
                };
                try {
                    const addCustomerData = await fetchApiWu('/cusprofile/v2/cust/customers/banks', requestOptions, "addCustomerBank")
                    showErrorOrThanxScreen(addCustomerData)
                } catch(e) {
                    showErrorOrThanxScreen()
                }
            }
        }
       
        if(loader && container) {
            let payOutList =  accountTypeList?.querySelectorAll('li')
            if (payOutList) {
              payOutList?.forEach((li) => {
                li.addEventListener("click", (e) => {
                  const valueFromEl = e.target.innerText;
                  selectAccountType = e.target.getAttribute("data-type");
                  completeFields.classList.add("d-none");
                  addBankFormError.classList.add("d-none");
                  Array.from(individualInputContainer).forEach((inputs) => {
                    inputs.classList.add("d-none");
                  });
                    resetFormDetails()
                    toggleClass(bankDropdownSection, "d-none", "d-block");
                    toggleClass(ClabeSection, "d-block", "d-none");
                    toggleClass(accountNumSection, "d-block", "d-none");
                    validateForm()
                });
              });  
            } 
            
            saveAddBank?.addEventListener('click', (e) => {
                if(formValidObj.isValid) {
                    triggerAddBank(customerID)
                } else {
                    completeFields.classList.remove('d-none')
                    validateInputs(addBank.querySelector(`.${selectAccountType}-input`))
                    if( selectAccountType === 'CLABE') {
                        if(!inputLabelBank.innerText) inputLabelBank.parentElement.classList.add('wu-input--error')
                    }
                }
            })

            if(token && customerID && senderCountry && receiverCountry) {
               
                try {
                    
                    try {
                        const {configVersion, ok} = await fetchApiWu(`/content/wucom/base/global/config/activeVersion.json`,{method: 'GET'},"activeVersion")
                        if(ok === false) {
                            showErrorOrThanxScreen({ok: false, wrongParams: true})
                            return;
                        }
                        const receiverHeaders = {
                            "Content-Type" : `application/json`
                        }
                        const receiverConfig = {
                            method: "POST",
                            headers: receiverHeaders,
                            body: JSON.stringify({
                                "destination":receiverCountry,
                                "isSWB":false,
                                "language":languageFromUrl,
                                "origination":senderCountry,
                                "payIn":PayIN,
                                "payOut":PayOut,
                                "version":"v3"
                            })
                        }
                        try {
                            const receiverData = await fetchApiWu(`/wuconnect/dcaas/csv-config/receiverconfig?configVersion=${configVersion}`,receiverConfig, "receiverConfig")
                            if(receiverData.ok === false) {
                                showErrorOrThanxScreen({ok: false, wrongParams: true})
                                return;
                            }
                            const {dataBanks, topBanks} = receiverData.d2bTemplate.find((x) => x.dataBanks)
                            toggleClass(loader, 'd-flex','d-none')
                            toggleClass(container, 'd-none', 'd-flex')
                            let dataCombinedBanks = []
                            if(dataBanks && dataBanks.length > 0) {
                                dataCombinedBanks = dataCombinedBanks.concat(dataBanks)
                            }
                            let fragment = document.createDocumentFragment();
                            dataCombinedBanks?.forEach(({name, value ,message}) => {
                                addLiTounorderedListBank(name, value, message, fragment)
                            })
                            unorderedListBank?.append(fragment)
                            banksInList = unorderedListBank?.querySelectorAll('li')
                            banksInList?.forEach((li) => {
                                li.addEventListener('click', (e) => {
                                    e.stopPropagation();
                                    toggleClass(bankSelectionText, "d-block", "d-none");
                                    resetFormDetails()
                                    validateForm()
                                    showHidePayoutDetails(selectAccountType)
                                    const valueFromEl = e.target.innerText
                                    toggleClass(estimatedDelText, "d-none", "d-block");
                                    inputLabelBank.parentElement.classList.remove('wu-input--error')
                                    bankSelected.setAttribute('data-bank',valueFromEl)
                                    bankSelected.setAttribute('data-code',e.target.getAttribute('data-value'))
                                    inputBank.value = valueFromEl
                                    inputBank.setAttribute('value', valueFromEl)
                                    inputBank.setAttribute('data-msg',e.target.getAttribute('data-msg'))
                                    inputLabelBank.innerText = valueFromEl
                                    const item = dataCombinedBanks.find((bank) => bank.value === e.target.getAttribute('data-value')) 
                                    dropdownBank.classList.remove('wuds-dropdown--active')
                                    toggleDropdown(true, unorderedListBank)
                                    toggleInputLabelBank(false)
                                })
                            })
                        }catch(e) {
                            // Error handled silently for security
                        }
                    } catch(e) {
                        // Error handled silently for security
                    } 
                } catch(e) {
                    // Error handled silently for security
                }
            } else {
                showErrorOrThanxScreen({ok: false, wrongParams: true})
            }
        }
    }
})()